import { setColorAlpha } from '../../util/setColorAlpha';
/**
 * Generator for commandbar base.
 */
export const commandBarStyles = (theme) => ({});
/**
 * Generator for customizations for split buttons.
 */
export const commandBarButtonStyles = (theme) => {
    const { isInverted, semanticColors, palette } = theme;
    const hoverBg = setColorAlpha(isInverted ? palette.neutralDark : palette.neutralPrimary, 0.2);
    const color = semanticColors.actionLink;
    const colorHover = semanticColors.actionLinkHovered;
    return {
        root: {
            color,
            borderBottom: `2px hidden`,
            backgroundColor: 'transparent',
        },
        rootHovered: {
            color: colorHover,
            background: hoverBg,
        },
        rootChecked: {
            color,
            background: 'transparent',
            borderBottom: `2px outset ${theme.palette.themePrimary}`,
        },
        rootCheckedHovered: {
            color: colorHover,
            background: hoverBg,
        },
        menuIcon: {
            background: 'transparent',
        },
        splitButtonMenuButton: {
            color,
            ':hover': {
                color: colorHover,
                background: hoverBg,
            },
        },
        splitButtonMenuButtonChecked: {
            color,
            background: 'transparent',
            ':hover': {
                color: colorHover,
                background: hoverBg,
            },
        },
    };
};
